// extracted by mini-css-extract-plugin
export default {"customTable":"Settings_customTable__+tUCR"};